import {l} from 'types/typescriptdefinisjoner_lederplan';
import {RessursFeilhåndtering} from '../RessursFeilhåndtering';
import _ from "lodash";
import {gettextCatalog} from 'angular-gettext';
import {regNavn} from '../tredjepartsTjenestenavn';
import {Pushtoken} from 'types/pushtoken';
import {Debugger} from "debug";

const debug:Debugger = require('debug')('AutentiseringsRessurs');

export class AutentiseringsRessurs {
    static regNavn = 'AutentiseringsRessurs';

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            AutentiseringsRessurs
        ]
    }

    private ressurs: ng.resource.IResourceClass<l.AutentisertOkModell>;

    constructor(private $resource: ng.resource.IResourceService,
                private ressursFeilhåndtering: RessursFeilhåndtering,
                private gettextCatalog: gettextCatalog) {
        this.ressurs = $resource<l.AutentisertOkModell>('/api/autentisering', {}, {
            validerToken: {method: 'GET', url: '/api/autentisering/validerToken'},
            autentiserv2: {method: 'POST', url: '/api/autentisering/v2'},
            hentKontekst: {method: 'GET', url: '/api/autentisering'},
            autentiserMedTotpReservekode: {method: 'POST', url: '/api/autentisering/autentiserMedTotpReservekode'},
            autentiserMedSmsOtpReservekode: {method: 'POST', url: '/api/autentisering/autentiserMedSmsOtpReservekode'},
            fornyTokenV2: {method: 'POST', url: '/api/autentisering/fornyTokenV2'},
            loggUtV2: {method: 'POST', url: '/api/autentisering/loggut'},
            loggutEnhet: {method: 'POST', url: '/api/autentisering/loggutEnhet'},
            loggutAlleEnheter: {method: 'POST', url: '/api/autentisering/loggutAlleEnheter'},
            opprett: {method: 'GET', url: '/api/autentisering/opprett'},
            valider: {method: 'POST', url: '/api/autentisering/valider'}
        });
    }

    validerToken(): l.ValiderTokenModell {
        debug('validerToken')
        return this.ressurs['validerToken'](
            {},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke validere innloggingstoken'))
        );
    }

    autentiserv2(spesifikasjon: l.InnloggingsSpesifikasjon): l.AutentiseringResponsModell {
        debug('autentiserv2', spesifikasjon)
        return this.ressurs['autentiserv2'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke autentisere bruker'))
        );
    }

    autentiserMedTotpReservekode(spesifikasjon: l.TotpReservekodeInnloggingsSpesifikasjon): l.AutentiseringResponsModell {
        debug('autentiserMedTotpReservekode', spesifikasjon)
        return this.ressurs['autentiserMedTotpReservekode'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke autentisere bruker med reservekode'))
        );
    }

    autentiserMedSmsOtpReservekode(spesifikasjon: l.SmsOtpReservekodeInnloggingsSpesifikasjon): l.AutentiseringResponsModell {
        debug('autentiserMedSmsOtpReservekode', spesifikasjon)
        return this.ressurs['autentiserMedSmsOtpReservekode'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke autentisere bruker med reservekode'))
        );
    }

    fornyTokenV2(tokenvarighet: l.Tokenvarighet): l.AutentisertOkModell {
        debug('fornyTokenV2', tokenvarighet)
        return this.ressurs['fornyTokenV2'](
            {tokenvarighet: tokenvarighet},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke fornye autentiseringstoken'))
        );
    }

    hentKontekst(): l.AutentisertOkModell {
        debug('hentKontekst')
        return this.ressurs['hentKontekst'](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke hente kontekst for autentisert bruker'))
        );
    }

    /** Gjør loggut kall mot server med optional pushtoken som skal fjernes (ved utlogging fra ios/android) */
    loggut(pushToken: Pushtoken = null, vedOk: () => void = _.noop, vedFeil: Function = _.noop): l.OkRespons {
        debug('loggut')
        //gjør kall mot server som logger ut og herunder avreg apn token
        return this.ressurs['loggUtV2'](this.loggUtSpesifikasjon(pushToken), vedOk, vedFeil);
    }

    loggutEnhet(tokenId:string): l.OkRespons {
        debug('loggutEnhet', tokenId)
        return this.ressurs['loggutEnhet'](
          {tokenId:tokenId},
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke logge ut fra enheten'))
        );
    }

    loggutAlleEnheter(): l.OkRespons {
        debug('loggutAlleEnheter')
        return this.ressurs['loggutAlleEnheter'](
          {},
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke logge ut fra alle enheter'))
        );
    }

    private loggUtSpesifikasjon(fjernPushToken:Pushtoken):any{
        if(_.isNil(fjernPushToken)) return {};
        switch (fjernPushToken.type){
            case 'ios': return {apnToken: fjernPushToken.token};
            case 'android': return {androidToken : fjernPushToken.token};
            default: return {};
        }
    }

    private håndterFeil(melding: () => string) {
        return this.ressursFeilhåndtering.håndterRequestFeil(melding);
    }
}
